module.exports = __webpack_public_path__ + "static/media/BF.a6dec3ee.svg";